<!--User Profile page-->
<div class="container py-5">
  <div class="row">
    <div class=" col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="row">
            <div class="col-xs-10 offset-xs-1 col-sm-10 offset-sm-1 col-col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <!-- Card which holds the profile form -->
          <div class="card" id="profile_card">
            <!-- Heading - My Profile -->
            <div id="profile-header">
              {{ 'UserProfile.profileHeader' | translate }}
            </div>
            <!--Userprofile form card-->
            <div class="card-body" id="profile_card_body">

            <!-- This need to be change -->
            <div *ngIf="successResponse!=null" class="alert alert-success">
              {{ 'UserProfile.successMessage' | translate }}
             </div>
            <div *ngIf="failureResponse!=null" class="alert alert-danger">
              {{ 'UserProfile.failureMessage' | translate }}
             </div>
              <form (ngSubmit)="updateProfile()" [formGroup]="userProfileForm">
                <!-- Profile Page - Username -->
                <div class="row mt-3 form-group">
                    <div class="col-md-4 col-lg-3 col-xl-3 mr-4">
                          <label for="userName" id="profile_label_uname">{{ 'UserProfile.usernameLabel' | translate }}</label>
                        </div>
                      <div class="col-md-7 col-lg-8 col-xl-8">
                          <input type="text" class="form-control" id="profile_username" formControlName="username" value={{userProfile.username}} (focus)="usernameFocus = true"
                          (blur)="usernameFocus = false" [ngClass]="{'error-class':!userProfileForm.controls['username'].valid && userProfileForm.controls['username'].touched && !usernameFocus}">
                        <div *ngIf="!userProfileForm.controls['username'].valid && userProfileForm.controls['username'].touched && !usernameFocus"
                          class="validation-error-inline text-danger">
                          {{ 'UserProfile.usernameRequiredError' | translate }}
                        </div>
                      </div>
                  </div>
                          
                        <!-- Profile Page - Email -->
                        <div class="row mt-3 form-group">
                            <div class="col-md-4 col-lg-3 col-xl-3 mr-4">
                                <label for="email" id="profile_label_email">{{ 'UserProfile.emailLabel' | translate }}</label>
                              </div>
                            <div class="col-md-7 col-lg-8 col-xl-8">
                              <input type="email" class="form-control" id="profile_email" formControlName="email" value={{userProfile.email}} (focus)="emailFocus = true"
                              (blur)="emailFocus = false" keyup="emailValidation()" [ngClass]="{'error-class':(emailEmpty() && userProfileForm.controls['email'].touched && !emailFocus) || (emailValidation() && userProfileForm.controls['email'].dirty) }">
                            <div *ngIf="emailEmpty() && userProfileForm.controls['email'].touched && !emailFocus" class="validation-error-inline text-danger">
                                  {{ 'UserProfile.emailRequiredError' | translate }}
                            </div>
                            <div *ngIf="emailValidation() &&  userProfileForm.controls['email'].dirty" class="validation-error-inline text-danger">
                                  {{ 'UserProfile.emailInvalidError' | translate }}
                            </div>
                          </div>
                        </div>


                <!-- Profile Page - Password -->
                <div *ngIf="!ldap" class="row mt-3 form-group">
                    <div class="col-md-4 col-lg-3 col-xl-3 mr-4">
                           <label for="password" id="profile_label_pwd">{{ 'UserProfile.passwordLabel' | translate }}</label>
                        </div>
                      <div class="col-md-7 col-lg-8 col-xl-8">
                           <input type="password" class="form-control" id="profile_password" formControlName="password" value={{userProfile.password}} (focus)="passwordFocus = true" [(ngModel)]="password" required minlength="1"
                         (focus)= "passwordFocus = true" (blur)= "passwordFocus = false" [ngClass]="{'error-class':userProfileForm.controls['password'].touched  && !userProfileForm.controls['password'].valid && passwordValidation()}">
                         <div *ngIf=" userProfileForm.controls['password'].touched  && !userProfileForm.controls['password'].valid && passwordValidation() && passwordEmptyValue()"
                           class="validation-error-inline text-danger">
                           {{ 'UserProfile.passwordRequiredError' | translate }}
                        </div>
                       </div>
                </div>

                <!-- Profile Page - Confirm Password -->
                <div *ngIf="!ldap" class="row mt-3 form-group">
                    <div class="col-md-4 col-lg-3 col-xl-3 mr-4">
                          <label for="confirmPassword" id="profile_label_cnfpwd">{{ 'UserProfile.confirmPasswordLabel' | translate }}</label>
                        </div>
                    <div class="col-md-7 col-lg-8 col-xl-8">
                      <input type="password" class="form-control" id="profile_cnf_pwd" formControlName="cnf_password" value={{confirmPassword}}
                       (focus)="confirmPasswordFocus=true" (blur)="confirmPasswordFocus=false" (keyup)="passwordValidation()" [(ngModel)]="confirmPassword" required minlength="1"
                       [ngClass]="{'error-class':userProfileForm.controls['cnf_password'].dirty && userProfileForm.controls['cnf_password'].touched && userProfileForm.controls['cnf_password'].valid   && passwordValidation() }"
                       >
                    <div *ngIf="userProfileForm.controls['cnf_password'].dirty && userProfileForm.controls['cnf_password'].valid   && passwordValidation()"
                        class="validation-error-inline text-danger">
                          {{ 'UserProfile.passwordsMismatchError' | translate }}
                    </div>
                    <div class="validation-error-inline text-danger" *ngIf="!passwordFocus && !confirmPasswordFocus  && passwordEmptyValue() && confirmPasswordEmptyValue()">
                      {{ 'UserProfile.confirmPasswordRequiredError' | translate }}
                    </div>
                    </div>
                  </div> 
                
                <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12" id="zsd_button_separation_line_Profile">
                 </div>

                <!--Save & Cancel Button-->
                <div class="form-group float-right mt-2">
                  <button *ngIf="!ldap" type="submit" class="btn zsd_button" id="zsd_cust_button_create" [disabled]="!validateSave() || ( emailValidation() ) ">{{ 'UserProfile.saveButton' | translate }}</button>
                  <button *ngIf="!ldap" type="button" class="btn zsd_button" id="zsd_cust_button_cancel" [routerLink]='["/home"]'>{{ 'UserProfile.cancelButton' | translate }}</button>
                
                  <!-- Using Same id in css because at a time only one will execute -->
                  <button *ngIf="ldap" type="button" class="btn zsd_button" id="zsd_cust_button_create" [routerLink]='["/home"]'>{{ 'UserProfile.okButton' | translate }}</button>
                </div>
              </form>
            </div>
          </div> 

        </div>
      </div>

    </div>
  </div>
</div>